import React from 'react';
import Product from './product';
import XSeries24Image from '../images/products/x-series-24-smokeless-fire-pit.jpg';
import LuxeveImage from '../images/products/luxeve-fire-pit-bronze-vein.jpg';
import OutpostGrillImage from '../images/products/breeo-outpost-grill-with-bag.jpg';

const Products = () => {
    const productData = [
        {
            name: 'X Series 24 Smokeless Fire Pit',
            url: 'https://breeo.co/products/x-series-24-smokeless-fire-pit',
            image: {
                alt: 'X Series 24 Smokeless Fire Pit',
                src: XSeries24Image
            },
            price: '$579'
        },
        {
            name: 'Luxeve® Smokeless Fire Pit - Bronze Vein',
            url: 'https://breeo.co/products/luxeve-fire-pit-bronze-vein',
            image: {
                alt: 'Luxeve® Smokeless Fire Pit - Bronze Vein',
                src: LuxeveImage
            },
            price: '$1,799'
        },
        {
            name: 'Outpost™ Grill',
            url: 'https://breeo.co/products/breeo-outpost-grill-with-bag',
            image: {
                alt: 'Outpost™ Grill',
                src: OutpostGrillImage
            },
            price: '$140'
        }
    ];

    return (
        <div className="section">
            <div className="container md:px-0">
                <h2 className="mb-8 md:mb-12 text-center">Featured Products</h2>
                <ul className="w-full md:flex">
                    {productData.map((product, key) => {
                        return <Product product={product} key={key} />;
                    })}
                </ul>
            </div>
        </div>
    );
};

export default Products;
